<template>
  <div>
    <div class="text-right">
      <b-button size="sm" class="btn btn-primary add-button mb-1" variant="primary" @click="()=>saveData()">
        <i class="fa-solid fa-floppy-disk"></i>
        {{ $t('operations.save') }}
      </b-button>
    </div>
    <div v-for="(affiliateWeekDays,day) in affiliateDays" v-bind:key="day">
      <b-row no-gutters>
        <b-col cols="2">
          <b-form-checkbox v-model="affiliateWeekDays['open']" class="md-primary text-capitalize">
            {{ $t(weekDays[day].toLowerCase()) }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="5" >
          <div class="px-1">
            <b-form-input  type="text" v-model="affiliateWeekDays['openHour']" v-bind:disabled="!affiliateWeekDays.open"/>
          </div>
        </b-col>
        <b-col cols="5">
          <div class="px-1">
            <b-form-input  type="text" v-model="affiliateWeekDays['closeHour']"  v-bind:disabled="!affiliateWeekDays.open"/>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Affiliate from '@/model/affiliate/Affiliate';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import { mapActions, mapGetters } from 'vuex';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import CalendarPicker from '@/components/widget/picker/calendarPicker';
import mixinBase from '@/components/mixin/mixinBase';

export default {
  name: 'AffiliateEditTimes',
  components: {
    CalendarPicker,
  },
  mixins: [mixinPermissions, mixinNotifications, mixinBase],
  data: () => ({
    affiliateDays: {}
  }),
  props: {
    affiliateId:{
      required: true,
      default: null
    },
    value: {
      required: true,
      default: () => ({})
    }
  },
  watch: {
    value: {
      handler() {
        this.affiliateDays = this.initData(this.value);
      },
      immediate: true
    }
  },
  created() {

  },
  computed: {
    ...mapGetters('affiliate', ['']),
    weekDays: () => ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
    openingTime: {
      get() {
        if (this.value == null) {
          return {};
        }
        return { ...this.value };
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    ...mapActions('affiliate', ['updateAffiliateTime']),
     initData(affiliateDays) {
      affiliateDays = affiliateDays != null ? { ...affiliateDays } : {};
      let totalDays = Object.keys(affiliateDays).length;
      let updated = false;
      this.weekDays.forEach((day, index) => {
        if (Array.isArray(affiliateDays[index])) {
          return;
        }
        affiliateDays[index] = {
          open: index !== 0 && index !== 6,
          openHour: '07:00',
          closeHour: '19:00'
        };
        updated = true;
      });
      console.log("affiliateDays", { affiliateDays, totalDays });
      if (updated) {
        if (totalDays <= 6) {
          setTimeout(this.saveData, 1500);
        }
      }
      return affiliateDays;
    },
    saveData(){
      let $this = this;
      this.updateAffiliateTime({
        id: this.affiliateId,
        openingTime: this.affiliateDays
      }).then(affiliate=>{
        $this.showSuccessNotification(this.$t('globalMessages.updateDataSuccess', { system: this.$t('menu.affiliatesTime') }));
        $this.$emit("submitted", affiliate);
        $this.$emit("updated", affiliate.id);
        $this.openingTime = affiliate.openingTime;
      }).catch(err=>{
        $this.showServerErrorNotification('updateDataError','symbols', err)
      });
      }
  }
};
</script>

<style scoped>
.table-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1rem;
}

.add-button {
  margin-left: 1rem;
}
</style>
